import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";
import { translate2 } from "../trans2";
function getProofHeaders(claimSubmission) {
  const ProofHeaders = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1,
    }),
    new InMemoryHeader({
      title: "globals.name",
      type: new InMemoryString("Name"),
      sortable: false,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "globals.date",
      type: new InMemoryDate("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "headers.inmemoryfiles.type_of_file",
      type: new InMemoryString("ProofType"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "enums.Claims",
      type: new InMemoryString("ClaimLines[]", {
        getString: (item) => {
          console.log(item, claimSubmission)
          if (item.ClaimLines === null || item.ClaimLines === undefined) {
            return "";
          }
          const claims = [];
          for (let i=0; i<claimSubmission.Claims.length; i++) {
            console.log(i+1, item.ClaimLines.indexOf(i+1) > -1)
            if (item.ClaimLines.indexOf(i+1) > -1) {
              if (claimSubmission.Claims[i].PlanBenefit!== null && claimSubmission.Claims[i].PlanBenefit!== undefined) {
                claims.push(translate2(claimSubmission.Claims[i].PlanBenefit.Benefit, "Name")+" ("+ (i+1).toString() + ")");
              }
            }
          }
          return claims.join(", ")
        },
      }),
      sortable: false,
      visible: true,
      searchable: false,
    }),
  ];
  return ProofHeaders;
}
export default getProofHeaders;
